import {
  AREAS_REQUEST,
  AREAS_FAILURE,
  FETCH_AREAS_SUCCESS,
  CREATE_AREAS_SUCCESS,
  UPDATE_AREAS_SUCCESS,
  DELETE_AREAS_SUCCESS,
} from "../action/types";

const INITIAL_STATE = {
  data: [],
  total: 0,
  loading: false,
  error: null,
};

const getEntityId = (item) => item?.id || item?._id;

const upsertArea = (areas, area) => {
  const areaId = getEntityId(area);
  if (!areaId) return areas;

  const exists = areas.some((item) => getEntityId(item) === areaId);
  if (!exists) return [area, ...areas];

  return areas.map((item) => (getEntityId(item) === areaId ? area : item));
};

const areasReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AREAS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case AREAS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FETCH_AREAS_SUCCESS:
      return {
        ...state,
        loading: false,
        data:
          action.payload?.data ??
          (Array.isArray(action.payload) ? action.payload : []),
        total:
          action.payload?.total ??
          (Array.isArray(action.payload) ? action.payload.length : 0),
      };
    case CREATE_AREAS_SUCCESS:
      {
        const exists = state.data.some(
          (item) => getEntityId(item) === getEntityId(action.payload),
        );
        return {
          ...state,
          loading: false,
          data: upsertArea(state.data, action.payload),
          total: exists ? state.total : state.total + 1,
        };
      }
    case UPDATE_AREAS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: upsertArea(state.data, action.payload),
      };
    case DELETE_AREAS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: state.data.filter((item) => getEntityId(item) !== action.payload),
        total: Math.max(state.total - 1, 0),
      };
    default:
      return state;
  }
};

export default areasReducer;
